/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import styled from 'styled-components';
import { SYS_SPACE_RELATIVE_MD, SYS_SPACE_RELATIVE_XL } from '@oneaudi/unified-web-common';

interface WLTPContainerProps {
  theme: string;
  isAlpha?: boolean;
}

export const WLTPContainer = styled.div<WLTPContainerProps>`
  background-color: ${(props) =>
    props.isAlpha ? 'transparent' : props.theme.sys.color.canvas.default};
  padding-bottom: 24px;
  padding: ${(props) =>
    props.isAlpha ? `${SYS_SPACE_RELATIVE_MD} 0 ${SYS_SPACE_RELATIVE_XL}` : '0 0 24px'};

  .fg-wltp-items {
    margin: 0 5px 0 0;
  }

  sup a {
    font-feature-settings: normal !important;
    font-weight: 400 !important;
  }
`;

export const MediaDisclaimerContainer = styled.div<{ $show: boolean }>`
  display: ${(props) => (props.$show ? 'block' : 'none')};
  sup a {
    font-feature-settings: normal !important;
    font-weight: 400 !important;
  }
`;
